import requests from './httpService';
const SubjectService = {
  getAllSubject(id) {
    return requests.post(`/subject/find`);
  },
  
  creteSubject(body){
    return requests.post('/subject/add',body); 
  },
  deleteSubject(body){
    return requests.delete(`/subject/${body._id}`); 
  },

  upadeSubject(body) {
    return requests.put(`/subject/${body._id}`,body); 
  },

  getSubjectNameById(body){
    return requests.post('/subject/getSubjectNameById',body);
  },


};

export default SubjectService;
